import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const sasManagersApi = factory.get("sasManagers");

const initialState = {
  managers: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      search: "",
      enabled: null,
    },
  },
};

export const sasManagersSlice = createSlice({
  name: "sasManagers",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setManagers: (state, action) => {
      state.managers.data = action.payload.data.data;
      state.managers.total = action.payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.managers.filters = {
        ...state.managers.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.managers.filters = initialState.managers.filters;
    },
  },
});

export const { setLoading, setManagers, setFilters, resetFilters } =
  sasManagersSlice.actions;

export default sasManagersSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().sasManagers.managers.filters;
    dispatch(setLoading("managers"));
    const res = await sasManagersApi.index(filters);
    dispatch(setManagers(res));
    dispatch(setLoading("managers"));
  } catch (err) {
    dispatch(setLoading("managers"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] ?? "Failed to fetch managers",
      })
    );
    throw new Error(err);
  }
};

export const SasManagersCall = { index };
